import styled from "@emotion/styled";

import { theme } from "../../ThemeProvider/CandyTheme/ThemeShorthand";

export const PanelPositionWrapper = styled.div<{ position: [number, number] }>(props => ({
    position: "fixed",
    display: "block",
    left: props.position[0],
    top: props.position[1],
    height: 0,
    width: 0,
    overflow: "visible",
    zIndex: 10000000,
}));

export const MenuContent = styled.div<{ opened: boolean }>(props => ({
    position: "absolute",
    textAlign: "left",
    display: "block",
    pointerEvents: props.opened ? "all" : "none",
    opacity: props.opened ? 1 : 0,
    left: 0,
    bottom: props.opened ? 8 : -10,
    transition: [
        "bottom 0.18s cubic-bezier(0.22, 0.61, 0.36, 1)",
        "opacity 0.18s cubic-bezier(0.22, 0.61, 0.36, 1)",
    ].join(", "),
}));

export const IconText = styled.span(props => ({
    display: "none",
    marginRight: theme(props).size(1),
}));

export const BigRoundedIcon = styled.button<{ opened: boolean }>(
    props => ({
        display: "inline-flex",
        flexDirection: "row",
        alignItems: "center",
        color: theme(props).icons.color,
        border: 0,
        outline: 0,
        paddingLeft: theme(props).size(1),
        paddingRight: theme(props).size(1),
        height: theme(props).size(4),
        borderRadius: 8,
        textAlign: "center",
        boxSizing: "border-box",
        backgroundColor: "transparent",

        ":hover": {
            backgroundColor: theme(props).icons.hoverBackgroundColor,

            [`${IconText}`]: {
                display: "inline",
            },
        },

        ":focus-visible": {
            boxShadow: `0 0 0 2px ${theme(props).valueControls.highlightedBorderColor}, 0 0 0 2px ${
                theme(props).valueControls.focusedInsetColor
            } inset`,
            [`${IconText}`]: {
                display: "inline",
            },
        },

        ":active": {
            "> *": {
                position: "relative",
                top: 1,
                left: 1,
            },
        },
    }),
    props =>
        props.opened && {
            backgroundColor: theme(props).icons.hoverBackgroundColor,
            [`${IconText}`]: {
                display: "inline",
            },
        }
);

export const Panel = styled(MenuContent)(props => ({
    padding: theme(props).size([3, 4, 5, 4]),
    background: theme(props).keyPalette.primaryBackgroundColor,
    boxShadow: `0 0 8px 2px ${theme(props).legacy.shadowColor}`,
    borderRadius: theme(props).size(2),
    width: 400,
}));

export const Header4 = styled.h4({
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 300,
    marginTop: 24,
    marginBottom: 16,
});

export const Header2 = styled.h2({
    fontSize: "24px",
    lineHeight: "36px",
    fontWeight: 500,
    marginTop: 24,
    marginBottom: 16,

    ":first-of-type": {
        marginTop: 0,
    },
});

export const RadioGroupLine = styled.div(props => ({
    marginTop: theme(props).size(1),
}));

export const SecondaryText = styled.span(props => ({
    ...theme(props).typography.secondary.css(),
}));

export const PanelColumn = styled.div({
    marginRight: 32,
});

export const ViewModeItemCaption = styled.div({
    fontSize: `16px`,
    lineHeight: `24px`,
    fontWeight: 500,
});
